var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("h2", [_vm._v("DNS A-records")]),
          _vm._v(" "),
          _vm.loading
            ? [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: true, color: _vm.$constants.LOADING_COLOR },
                }),
              ]
            : [
                _c("p", { staticStyle: { color: "grey" } }, [
                  _vm._v(
                    "API rate limits: " +
                      _vm._s(_vm.rateReached) +
                      "/" +
                      _vm._s(_vm.rateLimits) +
                      " (per minute for one account)"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    attrs: { action: "", method: "post" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.save.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          padding: "13px 15px",
                          background: "#ffebeb",
                          display: "inline-block",
                          "font-size": "17px",
                        },
                      },
                      [
                        _c("label", [_vm._v("New IP:")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.new_ip,
                              expression: "new_ip",
                            },
                          ],
                          staticStyle: { padding: "3px 5px" },
                          attrs: {
                            type: "text",
                            required: "",
                            pattern:
                              "((^|\\.)((25[0-5])|(2[0-4]\\d)|(1\\d\\d)|([1-9]?\\d))){4}$",
                          },
                          domProps: { value: _vm.new_ip },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.new_ip = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.account,
                                expression: "account",
                              },
                            ],
                            staticStyle: { padding: "3px 5px" },
                            attrs: { name: "account", required: "" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.account = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _vm._l(_vm.items, function (item, key) {
                              return _c(
                                "option",
                                { domProps: { value: key } },
                                [_vm._v(_vm._s(item.email))]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("button", { attrs: { type: "submit" } }, [
                          _vm._v("Submit"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.items, function (item, key) {
                      return _c(
                        "div",
                        [
                          _c("h3", [_vm._v(_vm._s(item.email))]),
                          _vm._v(" "),
                          _vm._l(item.dns, function (dns, domain) {
                            return _c("div", [
                              _c("h5", { staticStyle: { cursor: "default" } }, [
                                _vm._v(_vm._s(domain)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                _vm._l(dns, function (dnsItem) {
                                  return _c(
                                    "label",
                                    {
                                      staticStyle: {
                                        background: "#dcdcdc80",
                                        padding: "7px 10px",
                                        "margin-right": "5px",
                                      },
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: dnsItem.selected,
                                            expression: "dnsItem.selected",
                                          },
                                        ],
                                        staticStyle: { "margin-right": "3px" },
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: Array.isArray(
                                            dnsItem.selected
                                          )
                                            ? _vm._i(dnsItem.selected, null) >
                                              -1
                                            : dnsItem.selected,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = dnsItem.selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    dnsItem,
                                                    "selected",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    dnsItem,
                                                    "selected",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(dnsItem, "selected", $$c)
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(dnsItem.name) +
                                          " - " +
                                          _vm._s(dnsItem.data) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }